import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import moment from "moment";

import { TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";

import "../../assets/style/componentPrincipal.css";
import "./pptosNew.css";
import "../../assets/style/tablesG.css";

import { Buscar } from "../general/buscadorPptoGastos/Buscar";
import { Crear } from "./Crear";

// import { ExportarPlanilla } from '../general/exportarPlanilla/ExportarPlanilla'
// import { VerReporte } from '../general/verReporte/VerReporte'
import { TableList } from "./tableList";

import { useBuyBudget } from "../../hooks/useBuyBudget";

export const PptosGastosLista = () => {
  const { buyBudgets, initGetAllBuyBudgets } = useBuyBudget();

  const [filters, setFilters] = useState({
    time: "year",
    estado: "todos",
    text: "",
    fecha: new Date(),
    fecha_desde: new Date(),
    fecha_hasta: new Date(),
    page: 1,
    rows: 10,
  });

  const handleChangeDateDesde = (newValue) => {
    setFilters({
      ...filters,
      fecha_desde: newValue,
    });
  };

  const handleChangeDateHasta = (newValue) => {
    setFilters({
      ...filters,
      fecha_hasta: newValue,
    });
  };

  useEffect(() => {
    initGetAllBuyBudgets(filters);
  }, [initGetAllBuyBudgets, filters]);

  return (
    <div className="p-container">
      <h1 className="p-title m-2">Presupuestos de gastos</h1>

      <DateFilters
        filters={filters}
        setFilters={setFilters}
        handleChangeDateDesde={handleChangeDateDesde}
        handleChangeDateHasta={handleChangeDateHasta}
      />

      <div className="flex">
        <Buscar filters={filters} setFilters={setFilters} />
        <div className="p-box-crear">
          <Crear />
        </div>
      </div>

      <div className="row p-box-filters">
        <div className="col p-box-filters-items">
          <Link to="/gastos/compras">Lista de gastos</Link>
          <Link to="/gastos/pptos" className="selected">
            Presupuestos de gastos
          </Link>
        </div>
      </div>

      <TableList
        dataList={buyBudgets}
        filters={filters}
        setFilters={setFilters}
        initGetAllBuyBudgets={initGetAllBuyBudgets}
      />
    </div>
  );
};

const DateFilters = ({
  filters,
  setFilters,
  handleChangeDateDesde,
  handleChangeDateHasta,
}) => {
  return (
    <>
      <div
        className="btn-group"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio1"
          autoComplete="off"
          checked={filters.time === "year" && "checked"}
          onChange={() => setFilters({ ...filters, time: "year" })}
        />
        <label
          className="btn btn-outline-light"
          htmlFor="btnradio1"
          style={{ color: filters.time === "year" ? "#8E24AA" : "#595759" }}
        >
          Anual ({moment(filters.fecha_desde).format("YYYY")})
        </label>

        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio2"
          autoComplete="off"
          checked={filters.time === "month" && "checked"}
          onChange={() => setFilters({ ...filters, time: "month" })}
        />
        <label
          className="btn btn-outline-light"
          htmlFor="btnradio2"
          style={{ color: filters.time === "month" ? "#8E24AA" : "#595759" }}
        >
          Mensual (
          <span style={{ textTransform: "capitalize" }}>
            {moment(filters.fecha_desde).format("MMMM")}
          </span>{" "}
          {moment(filters.fecha_desde).format("YYYY")})
        </label>

        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio3"
          autoComplete="off"
          checked={filters.time === "range" && "checked"}
          onChange={() => setFilters({ ...filters, time: "range" })}
        />
        <label
          className="btn btn-outline-light"
          htmlFor="btnradio3"
          style={{ color: filters.time === "range" ? "#8E24AA" : "#595759" }}
        >
          Rango
        </label>
      </div>

      {filters.time === "year" && (
        <div className="m-2 p-text-date-year">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year"]}
              label="Año"
              openTo="year"
              name="fecha_desde"
              minDate={new Date("2020-01-01")}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "month" && (
        <div className="m-2 p-text-date">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year", "month"]}
              label="Mes"
              openTo="month"
              name="fecha_desde"
              minDate={new Date("2020-01-01")}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "range" && (
        <div className="m-2 text-start flex justify-start p-text-date-range">
          <span>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="Mes desde"
                inputFormat="DD/MM/YYYY"
                name="fecha_desde"
                value={filters.fecha_desde}
                onChange={handleChangeDateDesde}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </span>
          <span style={{ marginLeft: "10px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="Mes hasta"
                inputFormat="DD/MM/YYYY"
                name="fecha_hasta"
                value={filters.fecha_hasta}
                onChange={handleChangeDateHasta}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </span>
        </div>
      )}
    </>
  );
};
